import { usePspGViewQuery } from 'hooks';
import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getUserRole } from 'utils/getUserRole';
import { handleSuccessGview } from './utils';

export function useViewPointCloudHandlers() {
    let { projectId } = useParams();
    const [permissions, setPermissions] = useState<Record<any, any>>();
    const { isError, error } = usePspGViewQuery({
        projectId: projectId as string,
        queryOptions: {
            onSuccess(data) {
                const { permissions } = handleSuccessGview(data.data);
                setPermissions(permissions);
            },
        },
    });

    const errorMsg = error?.response?.data?.response?.message;

    const roleTitle = useMemo(() => getUserRole(permissions), [permissions]);

    return { isError, errorMsg, roleTitle };
}
